import { Button, Group } from "@mantine/core";
import { openContextModal } from "@mantine/modals";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "next-i18next";
import { trackEvent } from "../../common/analytics";
import { createMatch, getEvent } from "../../common/api";
import { useBoard } from "../../common/boards/board.hooks";
import { EliminationMatchup, Event } from "../../common/events/event.schema";
import {
  DEFAULT_MATCH_POINTS,
  DEFAULT_TEAM_MATCH_POINTS,
} from "../../common/matches/match.schema";
import { useAuthStore } from "../../common/stores/auth.store";
import { isProd } from "../../common/util";
import Hider from "../common/Hider";
import EliminationAccordion from "./EliminationAccordion";
import EliminationBracket from "./EliminationBracket";
import { getHasTeams } from "./util";
const Eliminations = ({ event }: { event: Event }) => {
  // console.log("event :", event);
  const { t } = useTranslation();

  const { board } = useBoard();
  const user = useAuthStore((s) => s.user);

  const hasTeams = getHasTeams(event);
  // if (!members) return <></>;
  const openMatch = (matchup: EliminationMatchup) => {
    // const member = members.find((m) => m._id === matchup.members[0]);
    // console.log("members :", members);
    let maxPoints = board?.defaultEliminationPoints || DEFAULT_MATCH_POINTS;
    if (hasTeams) maxPoints = DEFAULT_TEAM_MATCH_POINTS;
    trackEvent("open_modal_add_match", { board: board?._id });
    openContextModal({
      title: t("addMatch"),
      modal: "addMatch",
      fullScreen: true,
      innerProps: {
        memberId: matchup.members[0],
        opponentId: matchup.members[1],
        event: event,
        requirePoints: true,
        hasTeams,
        maxPoints,
      },
    });
  };
  const queryClient = useQueryClient();
  const autoComplete = async () => {
    if (!board) return;
    let roundIndex = 0;
    let matchIndex = 0;
    const next = async () => {
      // const a =
      const refreshedEvent = await getEvent(event.shortLink);
      // console.log('refreshedEvent :', refreshedEvent);
      const matchup =
        refreshedEvent.eliminations[roundIndex].matchups[matchIndex];
      // console.log('matchup :', matchup);
      if (!matchup) return;
      matchIndex++;
      if (!matchup.complete && matchup.members[0] && matchup.members[1]) {
        const a = matchup.members[0];
        const b = matchup.members[1];
        const w = Math.random() > 0.5;
        await createMatch({
          members: [a, b],
          winner: w ? a : b,
          loser: w ? b : a,
          tournament: event._id,
          board: board._id,
          winnerPoints: hasTeams ? 45 : 15,
          loserPoints: Math.round(Math.random() * (hasTeams ? 44 : 14)),
        });
      }
      if (matchIndex < event.eliminations[roundIndex].matchups.length) {
        next();
      } else {
        matchIndex = 0;
        roundIndex++;
        if (roundIndex == event.eliminations.length) {
          queryClient.refetchQueries();
        } else {
          next();
        }
      }
    };
    next();
  };
  return (
    <>
      {user?.admin && !isProd && (
        <Group justify="right">
          <Button onClick={() => autoComplete()} variant="subtle" size="xs">
            Autocomplete elimination
          </Button>
        </Group>
      )}
      <Hider smallerThan="sm">
        <EliminationBracket event={event} openMatch={openMatch} />
      </Hider>
      <Hider largerThan="sm">
        <EliminationAccordion event={event} openMatch={openMatch} />
      </Hider>
    </>
  );
};
export default Eliminations;
